import React from 'react';
import Link from '../../common/TrackedLink';

const Commitment = () => {
	return (
		<section className="row commitment" id="warranties-and-guarantees">
			<div className="col header">
				<h2 className="title">We Stand Behind Every Product We Make</h2>
				<p>Your SentrySafe product was designed, built and thoroughly inspected at the factory for quality assurance, given normal use and care. SentrySafe warrants the quality and workmanship of your product according to the terms and conditions as stated in the <a href="/support/product-manuals">owners&#39; manuals</a>.</p>
			</div>
			<div className="callouts">
				<div className="col sm-2">
					<img className="icon" src={ require('../../../resources/img/icons/fire-guarantee-icon.png') } alt="After&#45;Fire Replacement" />
					<h3 className="sub-title">After&#45;Fire Replacement Program</h3>
					<p>If your safe goes through a fire, SentrySafe will send a replacement safe free of charge, so the things that matter most are protected for generations to come.</p>
				</div>
				<div className="col sm-2">
					<img className="icon" src={ require('../../../resources/img/icons/impact-resistance-icon.png') } alt="Fire Protection Guarantee" />
					<h3 className="sub-title">&#36;50,000 Fire Protection Guarantee</h3>
					<p>Get up to &#36;50,000 in insurance protection for your valuables.  Registration requirements and limitations apply.  See <Link to="/support/faqs/#warranties-and-guarantees">here</Link> for more details.</p>

				</div>
			</div>
		</section>
	);
};

export default Commitment;



// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/Commitment.js